// gestionnaire de traductions

import { IWizTranslatable } from "../../interfaces/iwiz-translatable";
import { WizComponentTranslationObj } from "../../obj/translation/wiz-translation.obj";
import { WizTranslationObj, WizCoreTranslationManager, WIZ_EVENT_TYPE, WizNumberUtils, WizDateUtils} from '@wizeoo/akm-core-lib';
import { WizEvent } from "../../events/wiz-event";
import { WizEventManager } from "../../events/wiz-event.manager";
import { WizRoot } from "../../components/views/wiz-root";

// singleton
export class WizTranslationManager extends WizCoreTranslationManager {

  /** Translation map by translatable component reference and translation key */
  // private componentMap: Map<IWizTranslatable, WizComponentTranslationVO[]>;
  private componentMap: Map<IWizTranslatable, Map<string, WizComponentTranslationObj>>;

  // pour appel externe de l'instance
  public static override getInstance(): WizTranslationManager {
    if (WizCoreTranslationManager.instance === null) {
      WizCoreTranslationManager.instance = new WizTranslationManager();

      // injection dans WizNumberUtils
      WizNumberUtils.tradInstance = this.instance;
      // injection dans WizDateUtils
      WizDateUtils.tradInstance = this.instance;

    }
    return WizCoreTranslationManager.instance as WizTranslationManager;
  }

  /** Cumulated translation loading
   * @param locales array of locales sorted by descendant preference
   */
  override async loadCumulatedTranslations(locales: string[]) {
    // let result: Promise<any>;
    if (locales && locales.length > 0) {
      this._loadingLocales = locales;
      this._currentLocales = [...locales]; // array copy
      await this.doLoadTranslations(this._loadingLocales);
      WizEventManager.dispatchRootEvent(new WizEvent(WIZ_EVENT_TYPE.TRANSLATION_LOADED, null, this._loadingLocales));
    }
    return Promise.resolve();
  }

  /* ************************************
          TRANSLATION APPLICATION
     ************************************ */

  /** References a translatable component inside component translation map
   * @param component: Component to reference
   */
  componentReference(component: IWizTranslatable, wizComponentTranslationVo?: WizComponentTranslationObj): void {
    if (!this.translationMap) {
      this.translationMap = new Map();
    }
    if (!this.componentMap) {
      this.componentMap = new Map();
    }
    if (component) {

      // Find or create component translation map
      if (!this.componentMap.get(component)) {
          this.componentMap.set(component, new Map());
      }

      // TODO: Remove condition after updated all component
      if (wizComponentTranslationVo) {
        let translation: WizTranslationObj;

        // Get translation
        if (!this.translationMap.has(wizComponentTranslationVo.translationKey)) {
          translation = {
            value: wizComponentTranslationVo.translationKey,
            key: wizComponentTranslationVo.translationKey
          };
        } else {
          translation = this.translationMap.get(wizComponentTranslationVo.translationKey);
        }
        wizComponentTranslationVo.translation = translation;

        // Register wizComponentTranslationVo of map component (Use for update langage)
        this.componentMap.get(component).set(wizComponentTranslationVo.property, wizComponentTranslationVo);
        // Call function translate on component
        component.wizTranslate([wizComponentTranslationVo]);
      }
    }
  }

  /** Unreferences a translatable component from component translation map
   * @param component: Copmonent to unreference
   */
  componentUnreference(component: IWizTranslatable): void {
    if (this.componentMap && this.componentMap.has(component)) {
      this.componentMap.delete(component);
    }
  }

  /**
   * Refresh of all referenced translatable components
   */
  refreshTranslations(): void {
    super.refreshTranslations();
    if (this.componentMap) {
      this.componentMap.forEach ((vos, comp) =>
        comp.wizTranslate([...vos.values()])
      );
    }
    // dispatch d'un event pour éventuel refresh des composants traductibles
    if(WizRoot.root()) {
      WizEventManager.dispatchEvent(WizRoot.root(), new WizEvent(WIZ_EVENT_TYPE.LOCALE_CHANGED, null, this._dateLocale));
    }
    
  }

  /**
   * Returns all the registered WizComponentTranslationVO for a given Component
   * @param pCompo The component to use as the key
   */
  getCompTrsVOFor(pCompo: IWizTranslatable): WizComponentTranslationObj[] {
    if (this.componentMap && this.componentMap.has(pCompo)) {
      return [...this.componentMap.get(pCompo).values()];
    }

    return [];
  }

}
